import { createSlice } from "@reduxjs/toolkit";
import { Token } from "../interface/Token";

const initialState: Token | null = null;



const tokenAuthenticationSlice = createSlice({
  name: "tokenAuthentication",
  initialState,
  reducers: {
    setTokenAuthenticationInStore: (state, action) => {
      return action.payload;
    }
  },
});

export const { setTokenAuthenticationInStore } = tokenAuthenticationSlice.actions;

export default tokenAuthenticationSlice.reducer;